"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StagingStationBehemoth = void 0;
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var CardRenderer_1 = require("../render/CardRenderer");
var MoonExpansion_1 = require("../../moon/MoonExpansion");
var Card_1 = require("../Card");
var StagingStationBehemoth = (function (_super) {
    __extends(StagingStationBehemoth, _super);
    function StagingStationBehemoth() {
        return _super.call(this, {
            name: CardName_1.CardName.STAGING_STATION_BEHEMOTH,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.SPACE],
            cost: 24,
            tr: { moonLogistics: 1 },
            metadata: {
                description: 'Gain 2 trade fleets. Raise the Logistic Rate 1 step.',
                cardNumber: 'M68',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.tradeFleet().tradeFleet().moonLogisticsRate();
                }),
            },
        }) || this;
    }
    ;
    StagingStationBehemoth.prototype.play = function (player) {
        player.increaseFleetSize();
        player.increaseFleetSize();
        MoonExpansion_1.MoonExpansion.raiseLogisticRate(player);
        return undefined;
    };
    return StagingStationBehemoth;
}(Card_1.Card));
exports.StagingStationBehemoth = StagingStationBehemoth;
